export const ContactInfo = {
    Acting: {
        agency: "TN Management",
        email: "info@tnmodelandtalent.com",
        phone: "(905) 850-9858"
    },
    Music: {
        agency: "Caitlin Klotz",
        email: "caitlin@caitlinklotz.com",
        phone: ""
    }
}